const colors = {
  white: 'rgb(255, 255, 255)',
  black: 'rgb(29, 31, 32)',
  blue: {
    primary: 'rgb(0, 0, 255)',
    aliceblue: 'rgb(240, 248, 255)',
  },
  gray: {
    primary: 'rgb(147, 147, 162)',
    lightGray: 'rgb(240,240,244)',
  },
  linearGradient: 'linear-gradient(-135deg, rgb(21, 134, 248) 0%, rgb(138, 37, 228) 100%)',
};

export default colors;
